import { useMediaQuery } from "@react-hook/media-query";

import type { IBreakpointsEnum } from "@constants";

export const useMinMedia = (breakpoint: IBreakpointsEnum) => {
  return useMediaQuery(`only screen and (min-width: ${breakpoint}px)`);
};

export const useMaxMedia = (breakpoint: IBreakpointsEnum) => {
  return useMediaQuery(`only screen and (max-width: ${breakpoint}px)`);
};
